import request from '@/service/http'

export function searchInit (data) {
  return request({
    url: 'api/TestPaperRead/searchInit',
    method: 'post',
    data,
  })
}

export function searchList (data) {
  return request({
    url: 'api/TestPaperRead/searchList',
    method: 'post',
    data,
  })
}

export function detail (data) {
  return request({
    url: 'api/TestPaperRead/getDetail',
    method: 'post',
    data,
  })
}

export function save (data) {
  return request({
    url: 'api/TestPaperRead/save',
    method: 'post',
    data,
  })
}

export function actualDetail (data) {
  return request({
    url: 'api/TestPaperRead/getActualDetail',
    method: 'post',
    data,
  })
}

export function actualSave (data) {
  return request({
    url: 'api/TestPaperRead/actualSave',
    method: 'post',
    data,
  })
}

export function randomSelectOneTest (data) {
  return request({
    url: 'api/TestPaperRead/randomSelectOneTest',
    method: 'post',
    data,
  })
}

